import React, { useEffect } from 'react';
//import { connect } from 'react-redux';
//import { Magnifier } from "react-image-magnifiers";
import 'react-image-lightbox/style.css';

import { quantityInputs } from '../../../../../utils';

function MediaOne( props ) {
    const product = props.event;

    useEffect( () => {
        quantityInputs();
    }, [] );

    const chooseImage = () => {
        if(product.images && product.images.length){
            const image2 = product.images.find( image => image.order_image === 2);
            if(image2){
                return image2.url_image;
            }
            return product.images[0].url_image;
        }
    }

    return (
        <>
            <div className={ `product-gallery` }>
                <div className="row m-0">
                    <figure className="product-main-image" index="0">
                        { product.payed === false ? <span className="product-label label-new">Free</span> : '' }
                        { product.top ? <span className="product-label label-top">Popular</span> : '' }
                        { product.discount ? <span className="product-label label-sale">{ product.discount }% off</span> : '' }
                        { ( 0 === product.stock ) ? <span className="product-label label-out">Sold Out</span> : '' }

                        {/* <Magnifier
                            imageSrc={ chooseImage() }
                            imageAlt={ product.name }
                            id="product-zoom"
                        /> */}
                        <img 
                            src={ chooseImage() }
                            alt={ product.name }
                            id="product-zoom"
                        />
                    </figure>
                </div>
            </div>
        </>
    )
};

export default MediaOne;